import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BEARER_ONLY } from '../interceptor/token.interceptor';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(
    private http: HttpClient,
  ) { }

  // PAYMENT METHODS API
  getPaymentMethods(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/payment-methods', {withCredentials: true});
  }

  createPaymentMethod(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/payment-methods', JSON.stringify(item), {withCredentials: true});
  }

  updatePaymentMethod(item: any, paymentMethodId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/payment-methods/${paymentMethodId}`, JSON.stringify(item), {withCredentials: true});
  }

  // PAYMENT SCHEMES API
  getPaymentSchemes(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/payment-schemes', {withCredentials: true});
  }

  createPaymentScheme(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/payment-schemes', JSON.stringify(item), {withCredentials: true});
  }

  updatePaymentScheme(item: any, paymentSchemeId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/payment-schemes/${paymentSchemeId}`, JSON.stringify(item), {withCredentials: true});
  }

  // PAYMENT SCHEME DETAILS API
  getPaymentSchemesDetails(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/payment-scheme-details', {withCredentials: true});
  }

  createPaymentSchemeDetails(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/payment-scheme-details', JSON.stringify(item), {withCredentials: true});
  }

  updatePaymentSchemeDetails(item: any, paymentSchemeDetailsId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/payment-scheme-details/${paymentSchemeDetailsId}`, JSON.stringify(item), {withCredentials: true});
  }

  // PAYMENT TERMS API
  getPaymentTerms(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/payment-terms', {withCredentials: true});
  }

  createPaymentTerms(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/payment-terms', JSON.stringify(item), {withCredentials: true});
  }

  updatePaymentTerms(item: any, paymentTermId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/payment-terms/${paymentTermId}`, JSON.stringify(item), {withCredentials: true});
  }

   // PAYMENT TYPES API
  getPaymentTypes(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/payment-types', {withCredentials: true});
  }

  createPaymentType(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/payment-types', JSON.stringify(item), {withCredentials: true});
  }

  updatePaymentType(item: any, paymentTypeId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/payment-types/${paymentTypeId}`, JSON.stringify(item), {withCredentials: true});
  }

  choosePaymentScheme(studentAssessment_id, item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/payment/assessment/${studentAssessment_id}/payment-scheme-submit`, JSON.stringify(item), {withCredentials: true});
  }

  previewPaymentScheme(studentAssessment_id, item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/payment/assessment/${studentAssessment_id}/payment-scheme-preview`, JSON.stringify(item), {withCredentials: true});
  }

  getStudentPaymentBalance(student_id): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/student/${student_id}/balances-payments`, {withCredentials: true});
  }

  uploadPayment(studentAssessment_id, item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/payment/assessment/${studentAssessment_id}/upload`, item, {withCredentials: true, context: new HttpContext().set(BEARER_ONLY, true) });
  }
  
  getPaymentList(filter): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `api/v1/payment/list?${filter?.student_id ? `filter%5Bstudent_id%5D=${filter?.student_id}&` : ''}include=student,term,assessment`, {withCredentials: true});
  }

  getPaymentListByPagination(url): Observable<any> {
    return this.http
    .get<any>(url, {withCredentials: true});
  }

  approvePayment(studentPayment_id, item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/payment/${studentPayment_id}/confirm`, JSON.stringify(item), {withCredentials: true});
  }
}
